import { CheckoutDirectDebitMethod } from '@checkout';
import {
  ClientBrandCode,
  RequestAction,
  RequestSource,
  TrustBox,
} from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'gb/sidedoor',
  buildFeatures: {},
  checkout: {
    directDebit: {
      method: CheckoutDirectDebitMethod.AccountNumberSortCode,
    },
  },
  defaultDomainId: DomainId.Beko,
  domainIdMapping: {
    [DomainId.Amica]: /amica\.[\w.-]*partners/,
    [DomainId.Baumatic]: /baum(?:atic)*\.[\w.-]*partners/,
    [DomainId.Beko]: /beko\.[\w.-]*partners/,
    [DomainId.Beko10YearPartsGuarantee]: /beko10(?:pg)*\.[\w.-]*partners/,
    [DomainId.Belling]: /bell(?:ing)*\.[\w.-]*partners/,
    [DomainId.Bush]: /bush\.[\w.-]*partners/,
    [DomainId.Candy]: /candy\.[\w.-]*partners/,
    [DomainId.Candy2YearGuarantee]: /candy2\.[\w.-]*partners/,
    [DomainId.Cda]: /cda\.[\w.-]*partners/,
    [DomainId.Comfee]: /comfee\.[\w.-]*partners/,
    [DomainId.Flavel]: /flavel\.[\w.-]*partners/,
    [DomainId.Grundig]: /grundig\.[\w.-]*partners/,
    [DomainId.Haier]: /haier\.[\w.-]*partners/,
    [DomainId.Hoover]: /hoover\.[\w.-]*partners/,
    [DomainId.Hoover2YearGuarantee]: /hoover2\.[\w.-]*partners/,
    [DomainId.Hotpoint]: /hotp(?:oint)*\.[\w.-]*partners/,
    [DomainId.Indesit]: /indesit\.[\w.-]*partners/,
    [DomainId.LEC]: /lec\.[\w.-]*partners/,
    [DomainId.Leisure]: /leisure\.[\w.-]*partners/,
    [DomainId.LG]: /lg\.[\w.-]*partners/,
    [DomainId.Matrix]: /matrix\.[\w.-]*partners/,
    [DomainId.MiraShowers]: /mira(?:showers)*\.[\w.-]*partners/,
    [DomainId.Stoves]: /stoves\.[\w.-]*partners/,
    [DomainId.Whirlpool]: /whirl(?:pool)*\.[\w.-]*partners/,
    [DomainId.Zenith]: /zenith\.[\w.-]*partners/,
  },
  modelNumberSearchEnabledBrands: [
    ClientBrandCode.Beko,
    ClientBrandCode.Hotpoint,
    ClientBrandCode.Indesit,
    ClientBrandCode.Whirlpool,
  ],
  requestAction: RequestAction.OnlineRegistration,
  retailerFieldEnabledBrands: [],
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
